import { useControlSelection } from './use-control-selection';
import { AppControlsPanel } from './app-controls-panel';
import { FunctionWriteSetup } from './function-write-setup';

/**
 * The selected saved version's budget and schedule controls. The logical App and its declared scheduled
 * jobs (with their declared labels) come from the server's control selection for exactly this artifact
 * and version; nothing is inferred from the display or the Artifact id. Until that read answers, or when it
 * is unavailable, nothing is shown (never a guessed budget or schedule).
 */
export function AppControlsMount({
  artifactId,
  versionId,
}: {
  artifactId: string;
  versionId: string;
}) {
  const control = useControlSelection(artifactId, versionId);
  if (!control.selection || !control.appId) return null;
  return (
    <>
      <AppControlsPanel
        artifactId={artifactId}
        versionId={versionId}
        logicalAppId={control.appId}
        revisionId={control.selection.revisionId}
        jobs={control.jobs.map((job) => ({
          jobId: job.id,
          label: job.label,
          schedule: job.schedule,
        }))}
      />
      <FunctionWriteSetup
        key={control.selection.revisionId}
        artifactId={artifactId}
        versionId={versionId}
        revisionId={control.selection.revisionId}
        functions={control.selection.functions}
        collections={control.selection.collections}
      />
    </>
  );
}
